import { IClassroomResource } from "../../classrooms";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IStatisticList, StatisticAction } from "../types";

export interface IStatisticListQueryParameters extends IPaginateable, IOrderable<"action" | "day" | "number"> {
    filters?: {
        action?: StatisticAction;
        classroom?: RelationalFilter<IClassroomResource>;
    };
}

export type IStatisticListQueryResult = IStatisticList;

const mapFilters = (filters: IStatisticListQueryParameters["filters"]) => {
    const { action, classroom } = filters ?? {};

    return {
        action,
        "classroom.uuid": mapRelationalFilter(classroom),
    };
};

export const statisticListQuery: IApiQueryFunction<IStatisticListQueryParameters> = ({
    filters,
    pagination,
    order,
}) => {
    return {
        method: "GET",
        url: `/statistics${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useStatisticListQuery = createApiQueryHook<IStatisticListQueryParameters, IStatisticListQueryResult>(
    statisticListQuery,
);
